<footer [ngClass]="{ 'logged-out': loggedOut }">
  <span
    class="tip"
    [ngStyle]="{ 'font-size': isDefaultTip ? '' : 'xx-small' }"
    title="Tip: You can drag to expand the width of the Word Add-in"
    >
    @if (isDefaultTip) {
      <mat-icon fontIcon="info_outline"></mat-icon>
    }
    @for (tip of tips; track $index; let i = $index) {
      <span
        >{{ tip }}
        @if (i < tips.length - 1) {
          <p></p
            >
          }</span>
        }
      </span>
      @if (!loggedOut) {
        <span class="tenant-info" title="Currently logged in with tenant {{ tenantName }}">
          <mat-icon fontIcon="people" class="tenant-icon"></mat-icon>
          <span class="tenant-text">
            {{ tenantName }}
          </span>
        </span>
        <mat-icon fontIcon="logout" class="logout-icon" title="Switch account" (click)="logout()" tabindex="0"></mat-icon>
      }
    </footer>
